/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_With_VoucherInputs */

const en_billing_with_voucher = /** @type {(inputs: Billing_With_VoucherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`with voucher`)
};

const id_billing_with_voucher = /** @type {(inputs: Billing_With_VoucherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dengan voucher`)
};

/**
* | output |
* | --- |
* | "with voucher" |
*
* @param {Billing_With_VoucherInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_with_voucher = /** @type {((inputs?: Billing_With_VoucherInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_With_VoucherInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_with_voucher(inputs)
	return en_billing_with_voucher(inputs)
});